/**
 * Takes the properties from legacy iBok
 * and maps it to an importable config object for React.
 *
 * @throws {ReferenceError} If IBOK.util.props hasn't been passed down
 * @return {object}
 * */
export function fetchOptionalLegacyProps() {
  if (
    typeof window === 'undefined'
    || !window.IBOK
    || !window.IBOK.util
    || !window.IBOK.util.props
  ) {
    return null;
  }

  return window.IBOK.util.props;
}

export function fetchLegacyProps() {
  const props = fetchOptionalLegacyProps();

  if (!props) {
    throw new ReferenceError('Cannot find iBok properties');
  }

  return props;
}

/**
 *
 * @param {string} uri The
 * */
// eslint-disable-next-line no-undef
export function getUrlSegments(uri) {
  const parts = uri.split('/');
  const n = parts.length;

  if (uri.slice(0, 5) === '/ibok') {
    return parts.slice(2, n);
  }

  if (uri[0] === '/') {
    return parts.slice(1, n);
  }

  return parts;
}

export function getBaseUrl() {
  const props = fetchOptionalLegacyProps();

  return props?.base_url || '/';
}

export function getUrlPrefix() {
  const baseUrl = getBaseUrl();

  if (baseUrl.endsWith('ibok/')) {
    return '/ibok';
  }

  return '';
}
